import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { coosBayConfig } from "./data";

export default function CoosBayPage() {
  return <OregonCityPageTemplate config={coosBayConfig} />;
}